export default "__VITE_ASSET__B8rwN9b7__"